import { parseAmount } from "@frontend/utils/amount";

import type { PlannedExpenseValues } from "../schemas/project";

/** What one expense comes to, or null while either factor is missing. */
export function plannedExpenseTotal(
  expense: PlannedExpenseValues,
): number | null {
  const unitPrice = parseAmount(expense.unitPrice);

  return null === unitPrice || null == expense.quantity
    ? null
    : unitPrice * expense.quantity;
}

/** What the expenses come to, or null until one of them can be summed. */
export function plannedExpensesTotal(
  expenses: PlannedExpenseValues[],
): number | null {
  let total: number | null = null;

  for (const expense of expenses) {
    const amount = plannedExpenseTotal(expense);

    if (null !== amount) {
      total = (total ?? 0) + amount;
    }
  }

  return total;
}
